import {
  Bar,
  CartesianGrid,
  Cell,
  BarChart as ReBarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  LabelList
} from 'recharts';

import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import _ from 'lodash';
import styled from 'styled-components';
import { v4 as uuId } from 'uuid';

export const BarChart = React.memo(({ data, title, height = 'auto' }) => {
  const theme = useTheme();

  const STATUS_COLOR = {
    Finalized: theme.custom.positive,
    Published: theme.custom.positive,
    'Awaiting Funder Verification': theme.custom.negative,
    'Funder Feedback Provided': theme.custom.neutral,
    'Awaiting Funder Feedback': theme.custom.negative,
    'Awaiting TI Verification': theme.custom.negative,
    'TI Feedback Provided': theme.custom.neutral,
    'Awaiting TI Feedback': theme.custom.negative,
    Draft: theme.custom.neutral,
    Waiting: theme.custom.negative
  };
  
  const getColor = status => {
    return STATUS_COLOR[status] || theme.custom.neutral;
  };

  return (
    <ChartContainer style={{ height }}>
      {title && (
        <ChartTitle onClick={() => { /* noop */ }} variant="body2" theme={theme}>
          {_.truncate(title)}
        </ChartTitle>
      )}
      <ResponsiveContainer height="100%" width="100%">
        <ReBarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="status" tick={false}/>
          <YAxis />
          <Tooltip />
          <Bar dataKey="total">
            {data.map(entry => (
              <Cell key={uuId()} fill={getColor(entry.status)} />
            ))}
            <LabelList dataKey="total" position="insideBottom" fill="rgba(0,0,0, 0.87)" />
          </Bar>
        </ReBarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
});

export const ChartContainer = styled.div`
  display: inline;
  text-align: center;
  width: 100%;
`;

export const ChartTitle = styled(Typography)`
  cursor: pointer;
  margin-bottom: 10px !important;
  margin-left: 40px !important;
  :hover {
    text-decoration: underline;
  }
`;
